import { Navigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';

export default function ProtectedRoute({ children }) {
  const { authState } = useAppContext();

  if (authState.isLoading) {
    return null; // or spinner
  }

  if (!authState.isAuth) {
    return <Navigate to="/" replace />;
  }

  return children;
}